import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ApiInterceptorProvider implements HttpInterceptor {
  constructor() { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    // let baseUrl = 'https://app.tuipoint.com';
    // let baseUrl = 'https://app-staging.tuipoint.com';
    // let baseUrl = 'http://13.55.117.65';
    let baseUrl = 'https://app.tootzee.com';
    
    // let baseUrl = 'http://127.0.0.1:8000';

    if (process.env.BASE_URL) {
      baseUrl = process.env.BASE_URL;
    }

    const url = `${baseUrl}/api/v2`;

    request = request.clone({
      url: url + request.url,
      setHeaders: {
        Authorization:
          'Bearer OT3mJeEJK2Wq2gwgp4YF7ySGM4PQEHXJ23spD1ClzhJG9DQcbp4sJCk6KaAV',
        'X-Requested-With': 'XMLHttpRequest',
        'ngrok-skip-browser-warning': 'true',
      },
    });
    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-interceptor/api-interceptor.ts